






import { Component, Vue, Prop } from "vue-property-decorator";
import VIcon from "@/components/VIcon.vue";

type TaxonomyData = {
  name: string;
  icon: string;
};

interface TaxonomyIconMap {
  [key: number]: TaxonomyData;
}

enum Level {
  SECTOR,
  CATEGORY,
  CLASS,
}

type TaxonomyMap = Record<Level, TaxonomyIconMap>;

const taxonomyMap: TaxonomyMap = {
  [Level.SECTOR]: {
    1: { name: "ABBIGLIAMENTO", icon: "shirt" },
    2: { name: "ABITAZIONE", icon: "home-02" },
    3: { name: "ALIMENTARI", icon: "food" },
    4: { name: "AUTOMOBILI", icon: "car-01" },
    5: { name: "BEVANDE/ALCOOLICI", icon: "drink" },
    6: { name: "CURA PERSONA", icon: "message-heart-circle" },
    7: { name: "DI SERVIZIO", icon: "building-08" },
    8: { name: "DISTRIBUZIONE", icon: "bezier-curve-03" },
    9: { name: "ELETTRODOMESTICI", icon: "washer" },
    10: { name: "ENTI/ISTITUZIONI", icon: "bank" },
    11: { name: "FARMACEUTICI/SANITARI", icon: "medical-cross" },
    12: { name: "FINANZA/ASSICURAZIONI", icon: "coins-hand" },
    13: { name: "GESTIONE CASA", icon: "roller-brush" },
    14: { name: "GIOCHI/ARTICOLI SCOLASTICI", icon: "book-closed" },
    15: { name: "INDUSTRIA/EDILIZIA/ATTIVITA", icon: "factory" },
    16: { name: "INFORMATICA/FOTOGRAFIA", icon: "monitor-03" },
    17: { name: "LOCALE", icon: "marker-pin-04" },
    18: { name: "MEDIA/EDITORIA", icon: "image-indent-left" },
    19: { name: "MOTO/VEICOLI", icon: "motorbike" },
    20: { name: "OGGETTI PERSONALI", icon: "heart-hand" },
    21: { name: "RUBRICATA", icon: "file-attachment-04" },
    22: { name: "SERVIZI PROFESSIONALI", icon: "cube-04" },
    23: { name: "TELECOMUNICAZIONI", icon: "signal-02" },
    24: { name: "TEMPO LIBERO", icon: "clock-plus" },
    25: { name: "TOILETRIES", icon: "spray" },
    26: { name: "TURISMO/VIAGGI", icon: "globe-05" },
    27: { name: "VARIE", icon: "layers-three-01" },
  },
  [Level.CATEGORY]: {},
  [Level.CLASS]: {},
};

export const TAXONOMY_ICON_SET = "taxonomy_icon_set";

@Component({
  name: "TaxonomyIcon",
  components: {
    VIcon,
  },
})
export default class TaxonomyIcon extends Vue {
  @Prop({ required: true }) readonly level!: Level;
  @Prop({ required: true }) readonly id!: number;

  get icon(): string | null {
    const levelMap: TaxonomyIconMap = taxonomyMap[this.level];

    if (levelMap && levelMap[this.id]) {
      return levelMap[this.id].icon;
    }

    return null;
  }
}
